<template>
	<div class="step">
		<ul>
			<li
				v-for="(li, index) in list"
				:key="index"
				:class="{ now: index === nowIndex }"
			>
				{{ index + 1 }}
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: 'BaseStep',
	props: {
		list: {
			type: [Array, Object, Function],
		},
		nowIndex: {
			type: Number,
			required: true,
		},
	},
};
</script>
